import React, { useRef, useState } from 'react';
import Filter from '@/pages/dashboard/components/NewFilter';
import { setBtnPointLog } from '@/pages/dashboard/utils/utils';
import { getDateDefault } from '../../utils/dateUtils';

/**
 *
 * @param props
 * @param props:filterConfirm 筛选器确认函数
 * @param props:filterReset 筛选器重置函数
 * @param props:setFilterLoading 筛选器loading设置，透传到筛选器组件内部，获取到筛选器列表时区等数据之后，设置为false，测试才可进行页面和组件中的接口调用
 * @param props:filterInit 初始化函数，会向外部传递初始化后的筛选器值
 * @returns
 */

const LtvFilter = (props: any) => {
  const { filterConfirm, filterReset, buttonLogConfig, setFilterLoading, filterInit, openSticky = false, children, isHaveFilterSave, timeZone = 0 } = props;
  // 筛选器路径
  const FILTER_PATH = 'monetization/ltv';
  const defaultDateVal = getDateDefault({ timeType: 'day', timeZone, startNum: 14, endNum: 1 });

  const filterValueRef = useRef<any>({
    rangeTime: defaultDateVal,
  });

  // 设置inputList
  const [inputList] = useState([
    {
      type: 'rangeDaily',
      key: 'rangeTime',
      default: defaultDateVal,
    },
  ]);

  const handleConfirm = (value: any) => {
    filterValueRef.current = value;
    const filterValue = {
      ...value,
      rangeTime: [
        value?.rangeTime?.[0]?.format('YYYY-MM-DD'),
        value?.rangeTime?.[1]?.format('YYYY-MM-DD'),
      ],
    };
    filterConfirm?.(filterValue);

    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    setBtnPointLog(buttonLogConfig, filterValue);
  };

  const handleReset = (value: any) => {
    filterValueRef.current = value;
    const filterValue = {
      ...value,
      rangeTime: [
        value?.rangeTime?.[0]?.format('YYYY-MM-DD'),
        value?.rangeTime?.[1]?.format('YYYY-MM-DD'),
      ],
    };
    filterReset?.(filterValue);

    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    setBtnPointLog(buttonLogConfig, filterValue, true);
  };

  const handleInit = (value: any) => {
    filterValueRef.current = value;
    filterInit?.({
      ...value,
      rangeTime: [
        value?.rangeTime?.[0]?.format('YYYY-MM-DD'),
        value?.rangeTime?.[1]?.format('YYYY-MM-DD'),
      ],
    });
    setFilterLoading(false);
  };

  return (
    <Filter
      openSticky={openSticky}
      path={FILTER_PATH}
      value={filterValueRef.current}
      latestDateType="ltv"
      inputList={inputList}
      onInit={handleInit}
      onConfirm={handleConfirm}
      onReset={handleReset}
      isHaveFilterSave={isHaveFilterSave}
    >
      {children}
    </Filter>
  );
};

export default LtvFilter;
